module.exports = __webpack_public_path__ + "static/media/doubleSink90.8e0111e9.png";